import {AxiosResponse} from "axios";

const emptyFn = () => {
    /* tslint:disable:no-empty */
};

const returnValidResponse = (response: AxiosResponse) => {
    if (response && response.data) {
        return response.data;
    }
};

export {emptyFn, returnValidResponse};


// WEBPACK FOOTER //
// ./src/api/utils.ts